import Vue from "vue";
import Vuex from "vuex";

// Modules
import alerts from "./modules/alerts/index";
import session from "@/store/modules/session/index";
import bioactives from "@/store/modules/bioactives/index";
import lotes from "@/store/modules/lotes/index";
import order from "@/store/modules/order/index";
import strain from "@/store/modules/strain/index";
import material from "@/store/modules/material/index";
import address from "@/store/modules/address/index";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    key_here_xyz: "0ZQXvkZ0rddyktNimruIMs2TUyFCAIkPisTmyzKGhcY",
    loader: false,
    cancelToken: undefined,
    filters: localStorage.getItem("testsFilters"),
    showSampleDataS3:
      localStorage.getItem("showSampleDataS3") == "true" ||
      localStorage.getItem("showSampleDataS3") == null,
  },
  mutations: {
    SET_LOADER(state, payload) {
      state.loader = payload;
    },
    SET_CANCEL_TOKEN(state, token) {
      state.cancelToken = token;
    },
    SET_FILTERS(state, filters) {
      localStorage.setItem("testsFilters", JSON.stringify(filters));
      state.filters = JSON.stringify(filters);
    },
    UPDATE_SHOW_SAMPLE_DATA(state, status) {
      localStorage.setItem("showSampleDataS3", status);
      state.showSampleDataS3 = status;
    },
  },
  actions: {},
  modules: {
    alerts,
    session,
    bioactives,
    lotes,
    order,
    strain,
    material,
    address
  },
});
